import React,{useEffect,useState,useRef} from 'react';
import {Link} from 'react-router-dom';
import moment from 'moment';
import 'moment-timezone';
import {
	Tag,Drawer,
	message,Space,
	Divider,Form,
	Button,Skeleton
} from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import ErrorPage from '../pages/ErrorPage';
import FieldComponent from './FieldComponent';
import ViewFormComponent from './ViewFormComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import {useAxios} from "../hooks/hooks";
import {cancelTokenSource} from "../hooks/hooks";

function EditFormComponent(props){
	const axios = useAxios();
	const source = cancelTokenSource;
	const {t} = useTranslation();
	const [error,setError] = useState(null);
	const [loaded,setLoaded] = useState(false);
	const [datasource,setDatasource] = useState([]);
	const [values,setValues] = useState([{}]);
	const [row,setRow] = useState({});
	const [groupValues,setGroupValues] = useState({});
	const [foreignLists,setForeignLists] = useState({});
	const [foreignEndpoints,setForeignEndpoints] = useState({});
	const [display,setDisplay] = useState([]);
	const [drawerVisibility,setDrawerVisibility] = useState({});
	const [deleteDrawerVisibility,setDeleteDrawerVisibility] = useState(false);
	console.log(props)
  const formRef = useRef(null);

	const layout = {
		layout:"vertical",
		labelCol: { span: 16 },
		wrapperCol: { span:16},
	};

	const tailLayout = {
		wrapperCol: { 
			offset:20,
			span: 4
		},
	};

	const onBack = () => {
		props.history.goBack();
	};

	const onFinish = (values) => {
		setLoaded(false);
		var data = {};
		for(var v in values){
			var fieldtype = props.endpoint.attributes[v].fieldtype.name;
			switch(fieldtype){
				case "date":
				case "time":
				case "datetime_local":
					data[v] = values[v] ? values[v].format("YYYY-MM-DD HH:mm:ss") : values[v];
					break;
				default:
					data[v] = values[v];
			}
		}
		console.log(values)
		if(props.endpoint.entity.is_meta === true){
			data._rev = row._rev;
		}
		console.log(props.id)
		if(props.id) return update(data);
		insert(data);
	};

	const insert = (values) =>{
		console.log("insert called")
		console.log(values)
		if (typeof values === "array") {
			for (var value of values) {
				axios.current.post(
					props.endpoint.namespace.code,
					value,
					// {cancelToken: cancelTokenSource.token}
				)
					.then(function (response) {
						var result = response.data
						if(result.error){
							message.error(result.error);
							return
						}
						message.success(
							t("Entity inserted successfully!",{entity:props.endpoint.entity.name})
						);
						if(props.onFinish){
							props.onFinish(values);
						}
					})
					.catch(function (error) {
						setError(error);
					})
			}
		} else {

			axios.current.post(
				props.endpoint.namespace.code,
				values,
				// {cancelToken: cancelTokenSource.token}
			)
				.then(function (response) {
					var result = response.data
					if(result.error){
						message.error(result.error);
						return
					}
					message.success(
						t("Entity inserted successfully!",{entity:props.endpoint.entity.name})
					);
					if(props.onFinish){
						props.onFinish(values);
					}
				})
				.catch(function (error) {
					setError(error);
				})
				.then(function () {
					setLoaded(true);
				});
		}
	};

	const update = (values) =>{
		console.log(values)
    	axios.current.put(
			props.endpoint.namespace.code
			+"/"+
			props.id,
			values,
			// {cancelToken: cancelTokenSource.token}
    )
		.then(function (response) {
			var result = response.data
      if(result.error){
				message.error(result.error);
				return
			}
			values = sanitizeRow(values);
			setValues(values);
			if(props.onUpdate){
				try{
					props.onUpdate(props.id,values,true);
				}catch(e){
				}
			}
			message.success(
				t("Entity #id updated successfully!",{
					entity:props.endpoint.entity.name,
					id:props.id
				})
			);
		})
		.catch(function (e) {
			if(props.onDelete){
				try{
					props.onDelete(props.id,null,false);
				}catch(e){
				}
			}
			setError(e);
		})
  	.then(function () {
			setLoaded(true);
		});
	};

	const handleGroupChange = (e) =>{
    const output = e.target.value;
		if(output === null) return;
    const group = props.endpoint.groups[e.target.id];
    var v = JSON.parse(JSON.stringify(values));
    for(var p in group.properties){
      const field = group.properties[p];
      if(undefined === v[field]) continue;
      if(undefined === output[p]) continue;
      if(foreignLists[field] === null){
				v[field] = output[p];
        formRef.current.setFieldsValue({
          [field] : output[p]
        });
        continue;
      }
      const len = foreignLists[field].length;
      for(var f =0;f<len;f++){
        if(foreignLists[field][f].display_field_value === output[p]){  
					v[field] = foreignLists[field][f].id;
          formRef.current.setFieldsValue({
            [field] : foreignLists[field][f].id
          });
          break;
        }
      }
    }
		updateForeignLists(v);
	}

	const handleFieldChange = (e) => {
		//updateForeignLists(values);
	}

	const sanitizeRow = (row)  => {
		for(var r in props.endpoint.attributes){
			if(undefined === row[r]){
				row[r] = null;
			}
			switch(props.endpoint.attributes[r].fieldtype.name){
				case "logical":
				case "switch":
				case "checkbox":
				case "question":
					row[r] = (row[r] === true || row[r] === 1);
					break;
	      case "datetime_local":
				case "date":
				case "time":
          row[r] = row[r] === null ? null : moment(row[r]);
       	  break;
				case "number":
					row[r] = row[r] === null ? null : Number(row[r]);
				default:
					//Nothing
			}
		}
		return row;
	};

	const getBoundList = async (code,a,params) => {
		try{
			var response = await axios.current.get(
			  "/bind/"+
				code
				+"/"+
				a,
        {params},
				// {cancelToken: cancelTokenSource.token}
			);
			return response.data;
		}catch(e){
			return [];
		}
	};

	const getBoundLists = async (code,attributes,params) => {
		var output = {
			lists:{},
			endpoints:{}
		};
		if(props.endpoint.entity.is_meta === true){
			for(var a in attributes){
				output.lists[a] = null;
				output.endpoints[a] = null;
			}
			return output;
		}
		for(var a in attributes){
			var foreign_table = attributes[a].mysql.foreign_table;
			var foreign_column = attributes[a].mysql.foreign_column;
			if(foreign_table === null || foreign_column === null){
				output.lists[a] = null;
				output.endpoints[a] = null;
				continue;
			}
			var bound_list = await getBoundList(code,a,params);
			var foreign_endpoint = null;
			if(props.endpoints){
				var endpoint = props.endpoints[props.endpoint.namespace.code][a].namespace;
				if(endpoint != null){
					foreign_endpoint = props.endpoints[endpoint] || null;
					if(foreign_endpoint !== null){
						foreign_endpoint = foreign_endpoint.create || null;
					}
				}
			}
			output.lists[a] = bound_list;
			output.endpoints[a] = foreign_endpoint;
		}
		return output;
	};

	const getRow = async (code,id) => {
		try{
			var response = await axios.current.get(
				code
				+"/"+
				id,
				// {cancelToken: cancelTokenSource.token}
			);
			if(response.data.length === 0) return {};
			return response.data[0];
		}catch(e){
			return {};
		}
	}

	const updateGroupValues = (row) =>{
		const group_values = {};
		for(var g in props.endpoint.groups){
			var group = props.endpoint.groups[g];
			group_values[g] = {};
			for(var p in group.properties){
				var k = group.properties[p];
				group_values[g][p] = row[k] || null;
			}
		}
		setGroupValues(group_values);
	};

	const updateForeignLists = async (row) => {
		if(undefined === row || row === null){
			row = JSON.parse(JSON.stringify(values));
		}
		var pk = props.endpoint.entity.is_meta === true ? "id" : props.endpoint.entity.mysql.primary;
		row[pk] = props.id || null;
		const bound_lists = 
			await getBoundLists(props.endpoint.namespace.code,props.endpoint.attributes,row)
		;
		setForeignLists(bound_lists.lists);
		setForeignEndpoints(bound_lists.endpoints);
	}

	const toggleDrawerVisibility = (field) => {
		var drawers = JSON.parse(JSON.stringify(drawerVisibility));
		drawers[field] = drawers[field] === true ? false : true;
		setDrawerVisibility(drawers);
	};

	useEffect(() => {
		console.log("called here")
		setLoaded(false);
		var drawers = {};
		for(var b in props.endpoint.attributes){
			drawers[b] = false;
		}
		setDrawerVisibility(drawers);
		var datasource = [];
		datasource = Object.keys(props.endpoint.attributes);
		setDatasource(datasource);
		var row = {};
		console.log("here")
		if(props.id){
			console.log("before promise")
			Promise.all([
				getRow(props.endpoint.namespace.code,props.id)		
			]).then((v) => {
				row = v[0];
				setDisplay(row.DISPLAY_FIELD);
				delete row.ID;
				delete row.DISPLAY_FIELD;
				row = sanitizeRow(row);
				setRow(row);
    			setValues(row);
				updateGroupValues(row);
				Promise.all([
					updateForeignLists(row)
				]).then((w) => {
					setLoaded(true);
				});
			});
		}
		else{
			row = props.values ? sanitizeRow(props.values) : sanitizeRow({});
    		setValues(row);
			// setValues(values.concat([row]));
			updateGroupValues(row);
			Promise.all([
				updateForeignLists(row)
			]).then((w) => {
				setLoaded(true);
			});
		}
	},[
 		props
	]);

	useEffect(()=>{
		return () =>{
			source.cancel();
			setLoaded(false);
		};
	},[]);

	if(loaded === false){
		return <Skeleton active/>;
	}
	if(loaded === true && error){
		return(
			<ErrorPage error={error}/>
		);
	}
	if(loaded === true && props.endpoint && props.endpoint.attributes && datasource && !error){
		return(
			<>
				{!props.id && (
					<PageHeader
						style={{padding:"0px 0px 16px 0px"}}
						title={
							t("New Entity",{entity:props.endpoint.namespace.name})
						}
						onBack={
							props.back === true ? onBack : false
						}
					/>
				)}
				{props.id && (
					<PageHeader
						style={{padding:"0px 0px 16px 0px"}}
						title={
							display
						}
						tags={
							<>
								<Tag color="blue">{props.endpoint.namespace.name}</Tag>
								<Tag color="geekblue">ID:{props.id}</Tag>
							</>
						}
						onBack={
							props.back === true ? onBack : false
						}
						extra={
							props.remove ? ( 
								props.endpoints ? 
								[
									<Button key="1" block danger onClick={() => setDeleteDrawerVisibility(true)}>
										<FontAwesomeIcon icon="trash"/>&nbsp;{t("Delete")}
									</Button>
								] :
								[
									<Button key="1" block danger>
										<Link 
											replace={true} 
											to={props.home+props.endpoint.namespace.code+"/delete/"+props.id}
										>
											<FontAwesomeIcon icon="trash"/>&nbsp;{t("Delete")}
										</Link>
									</Button>
								]
							) : 
							[]
						}
					/>
				)}
				<Form
					{...layout}
					initialValues={groupValues}
				>
					{props.endpoint.group_array.map((g) => (
						<FieldComponent
							name={g.name} 
						  key={g.code}
						  field={g.code}
						  fieldtype={g.fieldtype.name}
							foreignList={foreignLists[g.code]}
						  onChange={handleGroupChange}
						  required={false}
						  foreignLists={foreignLists}
							currentValues={values}
							currentproject={props.currentproject}
							currentDisabled={props.disabled}
							endpoints={props.endpoints}
						/>
					))}
				</Form>
				<Form
					name={"form-"+props.endpoint.namespace.code}
			    ref={formRef}
					{...layout}
					onFinish={onFinish}
					initialValues={values}
					onFieldsChange={handleFieldChange}
				>
					{datasource.map((field) => {
						if(
							props.endpoint && 
							props.endpoint.attributes && 
							props.endpoint.attributes[field]
						){
							return (
								<FieldComponent 
									name={
										<Space>
											<span>
												{t(props.endpoint.attributes[field].name)}&nbsp;
											</span>
											{foreignLists[field] && foreignEndpoints[field] != null && (
												<Button
													size="small"
													key={"btn-"+field}
													onClick={() =>{toggleDrawerVisibility(field)}}
												>
													<FontAwesomeIcon icon="plus"/>&nbsp;{t("New")}
												</Button>
											)}
										</Space>
									} 
									key={field} 
									field={field}
									currentproject={props.currentproject}
									foreignEndpoint={foreignEndpoints[field]}
									foreignList={foreignLists[field]}
						  		disabled={
										props.endpoint.attributes[field].has_group || 
										(props.disabled && props.disabled.indexOf(field) !== -1)
									}
						  		entity={props.endpoint.entity.table}
									onChange={handleFieldChange}
									fieldtype={
										foreignLists[field] ? 
										"foreign_key" : 
										props.endpoint.attributes[field].fieldtype.name
									} 
									required={
										props.endpoint.entity.is_meta === true ? 
										false : 
										props.endpoint.attributes[field].mysql.required
									}
									endpoints={props.endpoints}
            		/>
							);
						}
					})}
					<Divider/>
					<Form.Item 
						{...tailLayout}
					>
						<Button block type="primary" htmlType="submit">
							{props.id ? <FontAwesomeIcon icon="edit"/> : <FontAwesomeIcon icon="plus"/>}&nbsp;
							{t("Submit")}
						</Button>
					</Form.Item>
				</Form>
				{datasource.map((field) => {
					if(foreignEndpoints[field] !== null)
					return(
						<Drawer
								key={"dwr-"+field}
								title={t("Add a record to list")}
								open={drawerVisibility[field]}
								onClose={()=>{toggleDrawerVisibility(field)}}
								placement="left"
								width="75%"
							>
								<EditFormComponent
									endpoint={
										foreignEndpoints[field]
									}
									onFinish={()=>{updateForeignLists()}}
									history={props.history}
									currentproject={props.currentproject}
									endpoints={props.endpoints}
									values={props.values}
									disabled={props.disabled}
									back={false}
								/>
							</Drawer>
						);
				})}
				<Drawer
					title={t("Delete Record")}
					open={deleteDrawerVisibility}
					onClose={()=>{setDeleteDrawerVisibility(false)}}
					placement="left"
					width="75%"
				>
					{props.endpoints && (
					<ViewFormComponent
						home="/dashboard/"
						endpoints={props.endpoints}
						endpoint={
							props.endpoints[props.endpoint.namespace.code].create
						}
						remove={true}
						update={false}
						currentproject={props.currentproject}
						history={props.history}
						back={false}
					/>
					)}
				</Drawer>
			</>
		);
	}
}

export default EditFormComponent;
